import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { formatISO, isAfter, isBefore, isSameDay, isWithinInterval, startOfDay } from 'date-fns';
import { memo } from 'react';
import { Day, Days as DaysUI, Weekday, Weekdays } from '../../../../primitives/index.js';
const DaysComponent = ({
  days,
  weekdays,
  minDate,
  maxDate,
  rangeStart,
  rangeHighlightStart,
  rangeEnd,
  rangeHighlightEnd,
  onDayClick,
  onDayMouseEnter,
  onDayMouseLeave,
  onDayFocus,
  holidayDates,
  onDayBlur,
  selectedState,
  showHolidays
}) => _jsxs(_Fragment, {
  children: [_jsx(Weekdays, {
    children: weekdays.map(({
      label,
      weekend
    }) => _jsx(Weekday, {
      weekend: weekend,
      children: label
    }, label))
  }), _jsx(DaysUI, {
    showHolidays: showHolidays,
    children: days.map(({
      label,
      date
    } = {}, index) => {
      if (!date || isBefore(date, minDate) || isAfter(date, maxDate)) {
        return _jsx(Day, {
          disabled: true,
          showHolidays: showHolidays,
          children: label
        }, label || index);
      }
      const selected = Boolean(rangeStart && isSameDay(date, rangeStart) || rangeEnd && isSameDay(date, rangeEnd));
      const inRange = Boolean(rangeHighlightStart && rangeHighlightEnd && isWithinInterval(date, {
        start: rangeHighlightStart,
        end: rangeHighlightEnd
      }));
      const stateHolidays = selectedState && selectedState.value !== 'default' ? [...(holidayDates[selectedState.value] || []), ...(holidayDates.general || [])].map(range => ({
        ...range,
        startDate: startOfDay(new Date(range.startDate)),
        endDate: startOfDay(new Date(range.endDate))
      })) : [];
      const normalizedDate = startOfDay(date);
      const {
        isDateInSpecialRange,
        isSingleSpecial,
        isSchoolHoliday,
        isPublicHoliday
      } = stateHolidays.reduce((acc, range) => {
        return {
          ...acc,
          ...(range.startDate <= normalizedDate && normalizedDate <= range.endDate ? {
            isDateInSpecialRange: true
          } : null),
          ...(isSameDay(range.startDate, range.endDate) && isSameDay(date, range.startDate) ? {
            isSingleSpecial: true
          } : null),
          ...(range.type === 'school' && range.startDate <= normalizedDate && normalizedDate <= range.endDate ? {
            isSchoolHoliday: true
          } : null),
          ...(range.type === 'public' && range.startDate <= normalizedDate && normalizedDate <= range.endDate ? {
            isPublicHoliday: true
          } : null)
        };
      }, {
        isDateInSpecialRange: false,
        isSingleSpecial: false,
        isSchoolHoliday: false,
        isPublicHoliday: false
      });
      return _jsx(Day, {
        isPublicHoliday: isPublicHoliday,
        showHolidays: showHolidays,
        isSchoolHoliday: isSchoolHoliday,
        isSpecial: isDateInSpecialRange || isSingleSpecial,
        selected: selected,
        isSingeSpecial: isSingleSpecial,
        inRange: inRange,
        "data-date": formatISO(date, {
          representation: 'date'
        }),
        onClick: onDayClick,
        onMouseEnter: onDayMouseEnter,
        onMouseLeave: onDayMouseLeave,
        onFocus: onDayFocus,
        onBlur: onDayBlur,
        onMouseDown: onDayMouseEnter,
        onMouseUp: onDayMouseLeave,
        children: label
      }, label);
    })
  })]
});
export const Days = memo(DaysComponent);